export const iconFontAwesomeMedicalHealthFileWaveform = (
	<i className="fa-solid fa-file-waveform"></i>
);
